import React from 'react'
import moment from 'moment'
import ReactMarkdown from 'react-markdown'
import { withBlogPosts } from '../../providers/Blog'
import {
  Wrapper,
  Backdrop,
  BackdropContent,
  CategoryList,
  CategoryListItem,
  Title,
  TimeStamp,
} from './styles'
import Headings from '../../components/Headings'
import Code from '../../components/Code'
import CodeBlock from '../../components/CodeBlock'
import P from '../../components/P'
import A from '../../components/A'
import Img from '../../components/Img'
import { media, palette, sizes } from '../../style'
import { styled } from 'styletron-react'
import { padding } from 'lostyle'

const Markdown = styled(ReactMarkdown, {
  width: '100%',
  ...media('tabletLandscape', {
    maxWidth: '1000px',
  })
})
const Content = styled('div', {
  width: '100%',
  ...padding(sizes.spacing.gutter.mobile),
  fontSize: '16px',
  lineHeight: '1.5',
  ...media('tabletLandscape', {
    maxWidth: '1000px',
    ...padding(sizes.spacing.gutter.desktop),
  })
})


class BlogArticle extends React.Component {
  componentDidMount() {
    this.props.blog.actions.fetchSingle(this.props.match.params.slug)
  }
  filterBySlug = post => post.fields.slug === this.props.match.params.slug
  render() {
    if (this.props.blog.posts) {
      const postData = this.props.blog.posts.length > 0 && 
        this.props.blog.posts.filter(this.filterBySlug)
      if (postData === 'undefined' || postData.length === 0) {
        return <div>Could not find post {this.props.match.params.slug}</div>
      }
      if (postData[0]) {
        const { fields } = postData[0]

        return (
          <Wrapper>
            <Backdrop 
              // $gradient={palette.gradients.blueToPurple}
              // $sticky={this.state.stickyTitle}
              {...fields.heroTextColor && {
                $color: fields.heroTextColor
              }}
            >
              <BackdropContent>
                <TimeStamp>
                  {
                    moment(fields.date).calendar(null, {
                      sameDay: '[Today]',
                      lastDay: '[Yesterday]',
                      lastWeek: 'MMM Do, YYYY',
                      sameElse: 'MMM Do, YYYY',
                    })
                  }
                </TimeStamp>
                <Title>{fields.title}</Title>
                <CategoryList>
                  {
                    fields.categories.map((category, idx) => (
                      <CategoryListItem key={idx}>{category}</CategoryListItem>
                    ))
                  }
                </CategoryList>
              </BackdropContent>
            </Backdrop>
            <Markdown
              source={fields.content}
              renderers={{
                heading: Headings,
                inlineCode: Code,
                code: CodeBlock,
                paragraph: P,
                link: A,
                image: Img,
              }}
            />
          </Wrapper>
        )
      }
    }
    return (
      <Wrapper>
        <Content>
          Could not find post <Code value={'/' + this.props.blog.slug} />
        </Content>
      </Wrapper>
    )
  }
}

export default withBlogPosts(BlogArticle)


// WEBPACK FOOTER //
// ./src/pages/BlogArticle/index.js